import { useQuery } from '@tanstack/react-query';
import { backendProvider } from '../services/backend';

/**
 * Hook to check if user has completed registration
 * Returns true if user is a member of at least one team
 */
export const useRegistrationStatus = () => {
  const query = useQuery({
    queryKey: ['registration-status'],
    queryFn: () => backendProvider.auth.hasCompletedRegistration(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000,   // 30 minutes — keep through sustained outages
    retry: 1,
    // Registration only changes via the register form, which explicitly
    // invalidates this query on completion. Refetching on window focus turns
    // every tab-switch into a chance for a transient error to hijack the UI
    // (before the fetcher learned to throw). The teams.list() call is cheap
    // enough that we don't need focus-triggered refreshes anyway.
    refetchOnWindowFocus: false,
    refetchOnReconnect: true, // network is back — verify for real
  });

  return {
    // Only trust a definitive answer. On query error the last successful
    // value stays cached by TanStack; isError lets callers suppress the
    // /register redirect instead of bouncing a registered user to onboarding.
    isRegistered: query.data ?? false,
    isError: query.isError,
    isLoading: query.isLoading,
  };
};
